import { BreakpointQueryName, ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const basic: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[200]};
  padding: ${theme.remSize[150]};
  border: 1px solid ${theme.color.border.neutral.default.high};
  background: ${theme.color.background.neutral.default.lowest};
  border-radius: ${theme.remRounding['2XS']};
  position: relative;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-grow: 1;
  gap: ${theme.remSize[200]};
`;

export const textInfo: ThemedFunctor = ({ theme }) => css`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.remSize[50]};
  align-items: flex-start;
  max-width: 24rem;
`;

export const details: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[200]};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-direction: column;
  }
`;

export const clickableArea: ThemedFunctor = () => css`
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;
